<template>
    <div v-if="!loading">
        <div class="header-actions">
            <CorpId />
            <CompassButton
                :label="$t.__('developerPage.Widgets.add_widget')"
                type="primary"
                @click="createWidget"
                class="ml-3"
            />
        </div>

        <!-- TABLE -->
        <el-table
            v-if="widgets.length"
            :data="widgets"
            :default-sort="{ prop: 'name', order: 'ascending' }"
            border
        >
            <!-- NAME -->
            <el-table-column
                prop="name"
                :label="$t.__('common.labels.name')"
                width="200"
                sortable
                show-overflow-tooltip
            >
            </el-table-column>

            <!-- WEBSITE -->
            <el-table-column :label="$t.__('common.labels.address')">
                <template slot-scope="scope">
                    <a :href="scope.row.website" target="_blank" class="primary-50">{{
                        scope.row.website
                    }}</a>
                </template>
            </el-table-column>

            <!-- CODE TO INSERT -->
            <el-table-column :label="$t.__('developerPage.Widgets.code_to_insert')">
                <template slot-scope="scope">
                    <el-input
                        type="textarea"
                        :rows="4"
                        :readonly="true"
                        v-model="scope.row.formatted_hash"
                    >
                    </el-input>
                </template>
            </el-table-column>

            <!-- ACTION -->
            <el-table-column fixed="right" :label="$t.__('common.labels.actions')" width="250">
                <template slot-scope="scope">
                    <div class="flex-row">
                        <CompassButton
                            :label="$t.__('common.actions.edit')"
                            type="primary-contrast"
                            @click="editWidget(scope.row.id)"
                        />
                        <CompassButton
                            :label="$t.__('common.actions.delete')"
                            type="tertiary-destructive"
                            @click="deleteWidget(scope.row.id)"
                            class="ml-2"
                        />
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <div v-else class="placeholder well">
            {{ $l10n.__("Vous ne disposez d'aucun formulaire actif") }}
        </div>
    </div>
    <preloader :background="false" :display="true" v-else />
</template>

<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';
import LinkButton from 'vcomponents/utilities/LinkButton.vue';
import CorpId from 'vcomponents/developerPage/CorpId.vue';

export default {
    data() {
        return {
            loading: true,
            widgets: [],
        };
    },
    created() {
        this.getWidgets()
            .then((widgets) => (this.widgets = widgets))
            .finally(() => (this.loading = false));
    },
    components: {
        Preloader,
        LinkButton,
        CorpId,
    },
    methods: {
        getWidgets() {
            return new Promise((resolve, reject) => {
                this.$ajax.get(`/rest/developer/widgets`, {}, (response) => {
                    resolve(response);
                });
            });
        },
        createWidget() {
            Snippet.prepareForm();
        },
        editWidget(id) {
            Snippet.prepareForm(id);
        },
        deleteWidget(id) {
            let widget = this.widgets.find((w) => w.id == id);
            Snippet.remove(id)
                .then(() => {
                    this.loading = true;
                    this.widgets = this.widgets.filter((w) => w.id !== id);
                    this.loading = false;
                    Push.success(this.$l10n.__('Widget "%s" supprimé', widget.name));
                })
                .catch((_) =>
                    Push.error(
                        this.$l10n.__('Erreur lors de la suppression du Widget "%s"', widget.name),
                    ),
                );
        },
    },
};
</script>
